import { render, staticRenderFns } from "./payment_title.vue?vue&type=template&id=2836c9d2&scoped=true&"
import script from "./payment_title.vue?vue&type=script&lang=js&"
export * from "./payment_title.vue?vue&type=script&lang=js&"
import style0 from "./payment_title.vue?vue&type=style&index=0&id=2836c9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836c9d2",
  null
  
)

export default component.exports